export class SchemaReference {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "subject",
            "baseName": "subject",
            "type": "string",
            "format": ""
        },
        {
            "name": "version",
            "baseName": "version",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SchemaReference.attributeTypeMap;
    }
    constructor() {
    }
}
